import React from 'react';
import { Box, Icon, Text, HStack, IconName } from '@medely/ui-kit';

interface MfaStepItemProps {
  iconName: IconName;
  title: string;
  description: string;
}

export const MfaStepItem = ({ iconName, title, description }: MfaStepItemProps) => {
  return (
    <HStack alignItems="flex-start" gap={2}>
      <Icon name={iconName} variant="custom" />
      <Box flex={1}>
        <Text size="m" color="text.primary">
          {title}
        </Text>
        <Text size="m" color="text.secondary">
          {description}
        </Text>
      </Box>
    </HStack>
  );
};
